import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { ScreenService } from 'src/core/services/screen.service';
import { Select, Store } from '@ngxs/store';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { Observable  } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ControlPanel } from 'src/states/control-panel.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametresGlobauxDto } from 'src/api/models';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'control-panel';

  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }

  @Select(ControlPanelStore.isLoggedIn$) isLoggedIn$: Observable<boolean>;
  @Select(ControlPanelStore.globalParams$) globalParams$: Observable<ParametresGlobauxDto>;

  userLoggedIn = false;
  tenantSelected = false;
  navigationLogic: string = "notAuthorized";

  color: string;

  constructor(
    private sanitizer: DomSanitizer,
    private screen: ScreenService,
    private store: Store,
    private translate: TranslateService,
  ) {
    this.translate.setDefaultLang('fr');
    this.translate.use('fr');
    this.isLoggedIn$.subscribe(u => {
      this.userLoggedIn = u;
      if (u != null && u === true) {
        this.store.dispatch(new ControlPanel.GetNavigationMenu());
      }
    });
    this.store.dispatch(new ControlPanel.GetGlobalParams());
    this.globalParams$.subscribe(res => {
      if (res != null) {
        this.color = res.SiteColor;
        document.documentElement.style.setProperty(`--base-accent`, this.color);
        document.documentElement.style.setProperty(`--base-normal`, this.color);
      }
    });   
  }

  isAuthComplete() {
    return this.userLoggedIn && this.tenantSelected;
  }
}
